import { Suspense, useEffect } from 'react';
// ** Third Party Components
import { Row, Col, Container } from 'reactstrap';
import { BrowserRouter as Router, Switch, Route, useParams } from 'react-router-dom';
import '@styles/react/pages/page-booking.scss';
import ShopDefaultAvatar from '@src/assets/images/logo/OLI_APP_4C_LTBG.png';
import MyPetsLeftSide from './components/MyPetsLeftSide';
import { petsRoutes } from './routes';
import { useQuery } from 'react-query';
import { getExternalKey, getShopInfo } from '../../../apis';
import { useRecoilState } from 'recoil';
import shopState from '../../../recoil/atoms/current-shop';
import externalKeyState from '../../../recoil/atoms/auth/externalKey';
import useJwt from '@src/@core/auth/jwt/useJwt';
import useUserState from '../../../utility/hooks/useUserState';
import isEmpty from 'lodash/isEmpty';

const PetsApp = () => {
  const params = useParams();
  const { jwt } = useJwt();
  const [user] = useUserState();
  const [externalKey, setExternalKey] = useRecoilState(externalKeyState);
  const [shop, setShop] = useRecoilState(shopState);

  const beginLogin = () => {
    const clientId = jwt.getClientId();
    window.location.href = `/${clientId}?redirect=pets`;
  };

  useEffect(() => {
    if (!user) {
      beginLogin();
    }
  }, [user]);

  useQuery(
    'externalKey',
    async () => {
      const { data } = await getExternalKey();
      setExternalKey(data?.jwt);
      jwt.setToken(data?.jwt);
      return data?.jwt;
    },
    {
      enabled: !user && !externalKey && !!jwt.getClientId(),
    }
  );
  useQuery(
    'shopInfo',
    async () => {
      const { data } = await getShopInfo(params?.clientId);
      const { phoneNumber, phoneCode } = data.data;
      const shopInfo = { ...data.data, ...(phoneNumber && phoneCode && { phone: `+${phoneCode}${phoneNumber}` }) };
      setShop(shopInfo);
      return shopInfo;
    },
    {
      enabled: (!!externalKey || !!user) && isEmpty(shop),
    }
  );

  return (
    <>
      <div className="align-items-center pl-2 mb-2 mb-lg-5 d-none d-sm-none d-md-flex" style={{ height: 98 }}>
        <img
          className="img-fluid rounded mr-1"
          src={shop?.avatar || ShopDefaultAvatar}
          style={{ width: 98, height: 98, objectFit: 'contain' }}
        />
        <h4 className="mb-0">{shop?.name}</h4>
      </div>
      <Container className="booking">
        <Row className="row-eq-height">
          <Col md={0} lg={3}>
            <MyPetsLeftSide />
          </Col>
          <Col md={12} lg={8} xl={6}>
            <Router basename={`${params?.clientId}/pets`}>
              <Switch>
                {petsRoutes.map(route => (
                  // Render more <Route>s with the same paths as
                  // above, but different components this time.
                  <Route
                    key={route.id}
                    path={route.path}
                    exact={route.exact}
                    render={props => {
                      return (
                        <Suspense fallback={null}>
                          <route.component shopId={params.clientId} {...props} />
                        </Suspense>
                      );
                    }}
                  />
                ))}
              </Switch>
            </Router>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PetsApp;
